if (!customElements.get('collection-product-grid')) {
  customElements.define(
    'collection-product-grid',
    class CollectionProductGrid extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.storeLastVisitedCollection();
        this.scrollToProductsOnPaginationSearch();
      }
      storeLastVisitedCollection() {
        const path = window.location.pathname;
        const isCollection = path.includes('/collections/');

        if (isCollection) {
          const handle = path.split('/collections/')[1].split('/')[0];

          // Try to grab the collection title from the page (adjust selector to match your theme)
          const titleElement = document.querySelector('.collection-hero__title, .collection-title, h1');
          const title = titleElement ? titleElement.textContent.trim() : handle.replace(/-/g, ' ');

          sessionStorage.setItem('last_collection_handle', handle);
          sessionStorage.setItem('last_collection_url', `${path}${window.location.search}`);
          sessionStorage.setItem('last_collection_title', title);
        }
      }
      scrollToProductsOnPaginationSearch() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get('page');
        if (!page) return;

        const productsSection = document.querySelector('collection-product-grid');
        if (productsSection) {
          let totalOffset = 0;

          const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height-mobile')) || 0;

          const announcementBar = document.querySelector('.announcement-bar-timer-section-wrapper');
          const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
          const facetWrapperHeight = document.querySelector('.facets-wrapper') ? document.querySelector('.facets-wrapper').getBoundingClientRect().height : 0;

          totalOffset = headerHeight + announcementHeight + facetWrapperHeight;

          const elementPosition = productsSection.getBoundingClientRect().top + window.pageYOffset;

          let offsetPosition = elementPosition - totalOffset;


          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }

      }
    }
  );
}
